<template>
  <div class="dias-do-mes-select">
    <el-row :gutter="16">
      <el-col :span="8" v-for="option in options" :key="option.value">
        <div
          class="dias-do-mes-select__card"
          @click="handleSelect(option.value)"
          :class="{
            'dias-do-mes-select__card--selected': selected === option.value
          }"
        >
          <div class="dias-do-mes-select__card-content">
            <div
              class="title"
              :class="{
                'title--selected': selected === option.value
              }"
            >
              {{ option.title }}
            </div>
            <div
              class="subtitle"
              :class="{
                'subtitle--selected': selected === option.value
              }"
            >
              {{ option.subtitle }}
            </div>
          </div>
          <div class="dias-do-mes-select__card-icon">
            <MaterialIcon
              icon="check"
              size="16px"
              v-if="selected === option.value"
              :style="{ color: '#0055FF' }"
            />
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script setup lang="ts">
import MaterialIcon from "@/ui/components/Icons/MaterialIcon/MaterialIcon.vue";
import { computed } from "vue";

const props = defineProps<{
  modelValue: number | undefined;
}>();

const emit = defineEmits<{
  (event: "update:modelValue", value: number): void;
}>();

const selected = computed(() => props.modelValue);

const options = [
  {
    title: "Dia 10",
    subtitle: "de cada mês",
    value: 10
  },
  {
    title: "Dia 15",
    subtitle: "de cada mês",
    value: 15
  },
  {
    title: "Dia 20",
    subtitle: "de cada mês",
    value: 20
  }
];

const handleSelect = (value: number) => {
  emit("update:modelValue", value);
};
</script>

<style scoped lang="scss">
.dias-do-mes-select {
  display: flex;
  flex-direction: column;
  gap: 16px;

  &__card {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 1rem;
    border-radius: 0.5rem;
    cursor: pointer;
    border: 1px solid _map.get($map: $neutro, $key: 100);
    box-sizing: border-box;

    &--selected {
      border-color: _map.get($map: $azulPrincipal, $key: 700);
      background-color: _map.get($map: $azulPrincipal, $key: 50);
    }

    &-content {
      display: flex;
      flex-direction: column;

      .title {
        font-size: 14px;
        font-weight: 700;
        line-height: 1.25rem;
        color: _map.get($map: $neutro, $key: 400);

        &--selected {
          color: _map.get($map: $azulPrincipal, $key: 700);
        }
      }

      .subtitle {
        font-family: $fontFamily;
        font-weight: 400;
        font-size: 12px;
        line-height: 1.5rem;
        color: _map.get($map: $neutro, $key: 500);

        &--selected {
          color: _map.get($map: $azulPrincipal, $key: 700);
        }
      }

      &__icon {
        .material-symbols-rounded {
          color: _map.get($map: $azulPrincipal, $key: 700);
        }
      }
    }
  }
}
</style>
